module.exports = __webpack_public_path__ + "static/media/references.c89347ce.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/features/references.jpeg
// module id = 374
// module chunks = 0